import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import SongCard from '../components/SongCard';
import { useAuth } from '../hooks/useAuth';
import { spotifyApi, twitchApi, widgetApi, botApi } from '../api/api';

export default function Dashboard() {
  const { user } = useAuth();
  const [song, setSong] = useState(null);
  const [spotifyStatus, setSpotifyStatus] = useState(null);
  const [twitchStatus, setTwitchStatus] = useState(null);
  const [botStatus, setBotStatus] = useState(null);
  const [obsUrl, setObsUrl] = useState('');

  useEffect(() => {
    spotifyApi.status().then((r) => setSpotifyStatus(r.data)).catch(() => {});
    twitchApi.status().then((r) => setTwitchStatus(r.data)).catch(() => {});
    botApi.status().then((r) => setBotStatus(r.data)).catch(() => {});
    widgetApi.obsUrl().then((r) => setObsUrl(r.data.obs_url)).catch(() => {});
    spotifyApi.currentSong().then((r) => setSong(r.data)).catch(() => {});

    const interval = setInterval(() => {
      spotifyApi.currentSong().then((r) => setSong(r.data)).catch(() => {});
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const copyObsUrl = () => {
    navigator.clipboard.writeText(obsUrl);
    toast.success('OBS URL kopiert!');
  };

  const StatusBadge = ({ connected }) =>
    connected
      ? <Badge bg="success">Verbunden</Badge>
      : <Badge bg="secondary">Nicht verbunden</Badge>;

  return (
    <div>
      <h4 className="text-white mb-4">
        👋 Willkommen, {user?.username}!
      </h4>

      <Row className="g-3 mb-4">
        {/* Current Song */}
        <Col md={12}>
          <SongCard song={song} />
        </Col>
      </Row>

      <Row className="g-3">
        {/* Spotify Status */}
        <Col md={4}>
          <Card bg="dark" text="white" className="border-secondary h-100">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Card.Title className="mb-0">🎵 Spotify</Card.Title>
                <StatusBadge connected={spotifyStatus?.connected} />
              </div>
              {spotifyStatus?.connected && (
                <p className="text-muted small">{spotifyStatus.display_name}</p>
              )}
              <Button
                as={Link}
                to="/settings/spotify"
                variant="outline-success"
                size="sm"
              >
                Einstellungen
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Twitch Status */}
        <Col md={4}>
          <Card bg="dark" text="white" className="border-secondary h-100">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Card.Title className="mb-0">🟣 Twitch</Card.Title>
                <StatusBadge connected={twitchStatus?.main?.connected} />
              </div>
              {twitchStatus?.main?.connected && (
                <p className="text-muted small">
                  {twitchStatus.main.display_name}
                  {twitchStatus?.bot?.connected && (
                    <span className="ms-2 text-info">+ Bot: {twitchStatus.bot.display_name}</span>
                  )}
                </p>
              )}
              <Button
                as={Link}
                to="/settings/twitch"
                variant="outline-primary"
                size="sm"
              >
                Einstellungen
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Bot Status */}
        <Col md={4}>
          <Card bg="dark" text="white" className="border-secondary h-100">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <Card.Title className="mb-0">🤖 Chat Bot</Card.Title>
                <Badge bg={botStatus?.running ? 'success' : 'secondary'}>
                  {botStatus?.running ? 'Aktiv' : 'Gestoppt'}
                </Badge>
              </div>
              <Button
                as={Link}
                to="/bot"
                variant="outline-info"
                size="sm"
              >
                Bot-Einstellungen
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* OBS Widget */}
        <Col md={12}>
          <Card bg="dark" text="white" className="border-secondary">
            <Card.Body>
              <Card.Title>🖥️ OBS Widget URL</Card.Title>
              <div className="d-flex align-items-center gap-2">
                <code className="text-success flex-grow-1 text-truncate">{obsUrl}</code>
                <Button variant="outline-success" size="sm" onClick={copyObsUrl}>
                  📋 Kopieren
                </Button>
                <Button
                  as={Link}
                  to="/widget-generator"
                  variant="outline-secondary"
                  size="sm"
                >
                  Anpassen
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
